/**
 * Visitor-facing copy for the two very different ways a public gym lookup can
 * fail. GH #2588: both used to say "Gym not found", so during the 2026-07-29
 * upstream wobble a real, active gym's public catalog told a prospective family
 * the gym did not exist. A missing gym is permanent; a failed lookup is not.
 *
 * Shared by the API route (response body) and the public catalog page (on-screen
 * heading + message) so the two can never drift apart.
 */

/** The slug genuinely does not match a gym. Stays generic on purpose (#2351). */
export const GYM_NOT_FOUND_MESSAGE = 'Gym not found';

/** The lookup itself did not succeed. Honest, and offers the real recovery. */
export const GYM_LOOKUP_UNAVAILABLE_MESSAGE =
  "We couldn't load this gym's page just now. Please refresh in a moment.";

/**
 * Full-screen copy for the public catalog. The API bodies above stay short
 * because anything can read them; these are what a parent actually reads, so
 * each names the cause and the next step. Both screens used to be headed
 * "Error", which reads as permanent even above try-again copy.
 */
export const GYM_NOT_FOUND_SCREEN = {
  heading: "We couldn't find this gym",
  message: 'Double-check the link your gym shared with you — part of it may be missing.',
} as const;

export const GYM_LOOKUP_UNAVAILABLE_SCREEN = {
  heading: "We couldn't load this page",
  message: GYM_LOOKUP_UNAVAILABLE_MESSAGE,
} as const;
